import React, { useEffect, useState } from "react";
import { Link, useLocation, useHistory } from "react-router-dom";

import styles from "./NavBar.module.css";
import LogoImg from "../../../assets/images/LOGO KIPIT.png";
import IconInicioSesion from "../../../assets/images/icon-inicio-sesion.png";

import BgModal from "../../../assets/images/bg-login.jpg";

import {
  HomeOutlined,
  BankOutlined,
  UserOutlined,
  MailOutlined,
  PoweroffOutlined,
  SettingOutlined,
  LockOutlined,
} from "@ant-design/icons";
import { Modal } from "antd";
import "./ModalLogin.css";

import { Menu, ConfigProvider } from "antd";
import { updateFilters } from "../../../redux/portal/Action";
import { useSelector, useDispatch } from "react-redux";
import LoginForm from "../../components/formLogin/LoginForm";
import { logout } from "../../../redux/auth/Action";
const NavBar = ({ openModal }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const location = useLocation();
  const history = useHistory();
  const [current, setCurrent] = useState(location?.state?.key || "home");
  const currentUser = useSelector((state) => state.authReducer);
  const dispatch = useDispatch();

  const items = [
  ];

  const handleLinkClick = (path) => {
    if (location.pathname === path) {
      // Ya estás en la página a la que se está haciendo clic, así que no hagas nada
      return;
    }
    const initialState = {
      selectedTipo: null,
      minPrice: null,
      maxPrice: null,
      metrosCuadrados: 0,
      cantidadPisos: "todo",
      cantidadDormitorios: "todo",
      cantidadBanos: "todo",
      ordenar: "",
      currentPage: 1,
      total: 0,
      hasMore: false,
      ubicaciones: [],
      proyectos: [],
    };

    dispatch(updateFilters(initialState));
  };
  const showModalLogin = () => {
    setIsModalOpen(true);
  };

  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const onClick = (e) => {
    console.log("click ", e);
    //setCurrent(e.key);
  };
  const handleLogout = () => {
    console.log("Usuario desconectado");
    dispatch(logout());
    history.push("/home");
  };

  useEffect(() => {
    if (openModal === true) {
      setIsModalOpen(true);
    }
  }, [openModal]);
  return (
    <ConfigProvider
      theme={{
        components: {
          Menu: {
            horizontalItemHoverColor: "#154957",
            itemSelectedColor: '#154957',
            horizontalItemSelectedColor: '#15E384',
            activeBarHeight: 3,
            fontSize: 16,
          },
        },
      }}
    >
      <div className={styles.Header}>
        <Modal
          open={isModalOpen}
          onOk={handleOk}
          onCancel={handleCancel}
          footer={null}
          width={400}
        >
          <div
            className={styles.ModalLogin}
          >
            <div className={styles.SectionLeft}></div>

            <div className={styles.SectionRight}>
              <div className={styles.Logo}>
                <img src={LogoImg} alt="Logo" />
              </div>

              <LoginForm closeModal={handleOk} />

              <div className={styles.NoCuenta}>
                ¿No tienes una cuenta?{" "}
                <Link to="/register" className={styles.Registro}>
                  Regístrate
                </Link>
              </div>
            </div>
          </div>
        </Modal>

        <div className={styles.Logo}>
          <Link to={`/home`}>
            <img src={LogoImg} alt="Logo" />
          </Link>
        </div>

        {/* <div className={styles.Menu}>
          <Menu
            onClick={onClick}
            selectedKeys={[current]}
            items={items}
            mode="horizontal"
            style={{ width: "100%" }}
          />
          <div className={styles.MenuButtons} style={{ display: "flex" }}>
            {currentUser.token !== null ? (
              // Si el usuario ha iniciado sesión
              <Menu
                onClick={onClick}
                items={[
                  {
                    label: `${currentUser.nombre} ${currentUser.apellido} `,
                    icon: <UserOutlined />,
                    children: [
                      {
                        label: `${currentUser.username} `,
                        key: "mail",
                        icon: <MailOutlined />,
                      },
                      {
                        label: (
                          <Link to={`/edit-cliente/${currentUser.userId}`}>
                            Configurar cuenta
                          </Link>
                        ),
                        icon: <SettingOutlined />,
                        key: "configurar-cuenta",
                      },
                      {
                        label: (
                          <Link to={`/change-password/${currentUser.userId}`}>
                            Cambiar contraseña
                          </Link>
                        ),
                        icon: <LockOutlined />,
                        key: "cambiar",
                      },
                      {
                        label: (
                          <Link
                            onClick={() => {
                              handleLogout();
                            }}
                          >
                            Cerrar sesión
                          </Link>
                        ),
                        icon: <PoweroffOutlined />,
                        key: "logout",
                      },
                    ],
                  },
                ]}
                mode="horizontal"
                style={{ float: "right", minWidth: 0, flex: "auto" }}
              />
            ) : (
              // Si el usuario no ha iniciado sesión
              // <button
              //   type="button"
              //   className={styles.Primary}
              //   onClick={showModalLogin}
              // >
              //   <img src={IconInicioSesion} style={{ width: "15px" }} />
              //   <span
              //     className={styles.TextButton}
              //     style={{ marginLeft: "5px" }}
              //   >
              //     Iniciar sesión
              //   </span>
              // </button>
              <></>
            )
            }
          </div>
        </div> */}
      </div>
    </ConfigProvider>
  );
};

export default NavBar;
